"use strict";

(function(z){

    z.ProjectsCorporateClientsForm = z.FormView.extend({
        el:"#corporate_clients_form-modal",

        events: function() {

            return _.extend({}, z.FormView.prototype.events,{
                "click #corporate_clients_form-save-button": "_onSubmitForm",
                "change #corporate_clientsform-county-field": "_onCountyChange",
                "click #corporateClientsRepresentativeForm-add-button": "_onCreateClientsRepresentative",
                "click .edit-representative-form" : "_onEditRepresentativeForm",
                "click .delete-representative-form" : "_onDeleteRepresentativeRow"
            });
        },

        /**
         * Constructor.
         *
         * @return {undefined}
         */
        initialize: function() {

            z.FormView.prototype.initialize.apply(this, arguments);

            // Initializing Backbone Validation Library
            this._bindValidation();

            this.representativesCollection = new z.ProjectsRepresentativesCollection();
            this.localitiesCollection = new z.LocalitiesCollection();

            this.listenTo(this.localitiesCollection, 'add', this._onLocalitiesCollectionAdd);
            this.listenTo(this.localitiesCollection, 'reset', this._onLocalitiesCollectionReset);
            this.listenTo(this.representativesCollection, 'add', this._onRepresentativesCollectionAdd);
            this.listenTo(this.representativesCollection, 'remove', this._onRepresentativesCollectionRemove);
            this.listenTo(this.representativesCollection, 'reset', this._onRepresentativesCollectionReset);
            this.listenTo(this.representativesCollection, 'change', this._onRepresentativesCollectionChange);
        },

        /**
         * Method that renders the form
         *
         * @return {Object} - this object
         */
        render: function() {

            // Clean up the form
            this._cleanupForm();

            z.FormView.prototype.render.apply(this, arguments);

            // Initialize the chosen fields
            // this._initializeChosen();

            var title = this.getModalFormEditTitleText();

            // if (this.$el.find('.modal-title').text() === title) {
            //
            //     this.$el.find("#materialform-partNumber-field").prop("disabled", true);
            //     this.$el.find("#materialform-type-field").prop("disabled", true);
            // } else {
            //
            //     this.$el.find("#materialform-partNumber-field").prop("disabled", false);
            //     this.$el.find("#materialform-type-field").prop("disabled", false);
            // }


            return this;
        },

        /**
         * Get add entity route name.
         *
         * @return {string} - add entity route name
         */
        getAddEntityRouteName: function() {
            return 'addCorporateClients';
        },

        /**
         * Get edit entity route name.
         *
         * @return {string} - edit entity route name
         */
        getEditEntityRouteName: function() {
            return 'editCorporateClients';
        },

        /**
         * Get modal form add title text
         *
         * @return {string} - modal form add title text
         */
        getModalFormAddTitleText: function() {
            return Translator.trans('js.btn_add_corporate_clients');
        },

        /**
         * Get modal form edit title text
         *
         * @return {string} - modal form edit title text
         */
        getModalFormEditTitleText: function() {
            return Translator.trans('js.btn_edit_corporate_clients');
        },

        /**
         * Get error panel container id.
         *
         * @return {string} - the error panel id
         */
        getErrorPanelId: function() {
            return '#corporate_clients_form-error-panel';
        },

        /**
         * Get submit button selector.
         *
         * @return {string} - the submit button selector
         */
        getSubmitButtonSelector: function() {
            return '#corporate_clients_form-save-button';
        },

        /**
         * Get page path.
         *
         * @return {string} - the page path
         */
        getPagePath: function() {
            return 'corporate_clients';
        },

        /**
         * Get success event name.
         *
         * @return {string} - the success event name
         */
        getSuccessEventName: function() {
            return 'corporate_clients.success';
        },

        /**
         * Get form error message text.
         *
         * @return {string} - form error message text
         */
        getFormErrorMessageText: function() {
            return Translator.trans('js.error_message_corporate_clients_form');
        },


        /**
         * Collecting data from form inputs.
         *
         * @private
         * @return {Object} {{name: *, sapMaterialNumber: *, price: *}}
         */
        getFormData: function() {

            // Get the fields
            var $nameField     = this.$('#corporate_clientsform-name-field');
            var $typeField   = this.$('#corporate_clientsform-type-field');
            var $cuiField   = this.$('#corporate_clientsform-cui-field');
            var $countyField = this.$('#corporate_clientsform-county-field');
            var $localityField = this.$('#corporate_clientsform-locality-field');
            var $regNrField   = this.$('#corporate_clientsform-regNr-field');
            var $addressField   = this.$('#corporate_clientsform-address-field');
            var $ibanField   = this.$('#corporate_clientsform-iban-field');
            var $bankField   = this.$('#corporate_clientsform-bank-field');
            var $paymentTermField   = this.$('#corporate_clientsform-paymentTerm-field');
            var $statusField   = this.$('#corporate_clientsform-status-field');
            // var $countyVal = this._getCountyValue();
            // var $localityVal = this._getLocalityValue();

            return {
                'name'     : $nameField.val(),
                'type'   : $typeField.val(),
                'cui'   : $cuiField.val(),
                'regNr'   : $regNrField.val(),
                'county'   : $countyField.val(),
                'locality'   : $localityField.val(),
                // 'county_name': $countyVal,
                // 'locality_name': $localityVal,
                'address'   : $addressField.val(),
                'iban'   : $ibanField.val(),
                'bank'   : $bankField.val(),
                'paymentTerm'   : $paymentTermField.val(),
                'status'   : $statusField.val()
            };
        },

        /**
         * Method used to show a general error message if the user is
         * browsing the app on mobile
         *
         * @return {undefined}
         */
        showMobileAlert: function()
        {
            var errorMessage = Translator.trans('js.error_message_corporate_clients_form');

            // Display mobile alert
            this.$el.find('#corporate_clients-create-general-error-panel')
                .removeClass('hidden')
                .text(errorMessage)
                .fadeTo('slow', 1)
                .delay(3000)
                .fadeTo('slow', 0, function(){
                    this.hideMobileAlert();
                }.bind(this));
        },

        _isLoading: function (loading, $btn) {

            loading = loading ? loading : _.isUndefined(loading);

            if (typeof $btn === 'string') {
                $btn = $($btn);
            }

            var ladda = $btn.data('ladda') ? $btn.data('ladda') : $btn.ladda().data('ladda');

            if (loading) {
                ladda.start();
            } else {
                ladda.stop();
            }
        },

        /**
         * Method used to hide the error message if the form is submitted, or the modal has been closed
         *
         * @return {undefined}
         */
        hideMobileAlert: function()
        {
            this.$el.find('#corporate_clients-create-general-error-panel').addClass('hidden');
        },

        /**
         * Method that resets the form fields, resets the collections and
         * hides the tables holding data
         *
         * @private
         * @return {undefined}
         */
        _cleanupForm: function() {

            // Resetting form
            this._resetFields("corporate_clients_form");
        },

        /**
         * Method that hides the wrapper that holds the table
         *
         * @param {Object} $wrapperName - the div object that acts as a wrapper
         * @private
         * @return {undefined}
         */
        _hideWrapper: function($wrapperName) {

            $wrapperName.addClass("hidden");
        },


        /**
         * Method that resets the specified fields according to id passed
         *
         * @param {string} value Name of the id to search for
         * @private
         * @return {undefined}
         */
        _resetFields: function (value) {

            this.$('[id^=' + value + ']').val("");
        },

        /**
         * Method that fills in the tables with the representative data
         *
         * @param {object} model - The representative model
         * @private
         * @return {undefined}
         */
        _fillRepresentativesForm: function(model) {
            // Getting data from model
            var data = model.attributes.representatives;

            if (!data) {
                return;
            }

            // Showing table
            var $wrapperName = this.$('.representative-list');
            this._displayWrapper($wrapperName);

            // Pushing data in collection
            Object.keys(data).forEach(function(key) {

                var representative = {
                    name: data[key].name,
                    position: data[key].position,
                    phoneNumber: data[key].phoneNumber,
                    email: data[key].email
                };

                this.representativesCollection.push(representative);
            }.bind(this));
        },


        _isValidRepresentatives: function() {
            if (this.representativesCollection.size() > 0) {
                this.$('.representative-validation-error').addClass('hidden');
                return true;
            } else {
                var errorValidationRepresentative = Translator.trans('js.error_validation_representative');
                this.$('.representative-validation-error').removeClass("hidden").text(errorValidationRepresentative);
                return false;
            }
        },

        /**
         * Method that fills the form input fields with data coming from the model.
         * It is used when the form is being edited.
         *
         * @private
         * @return {undefined}
         */
        _fillForm: function() {
            this._fillRepresentativesForm(this.model);
            var map = {
                "corporate_clientsform-name-field": "name",
                "corporate_clientsform-cui-field": "cui",
                "corporate_clientsform-type-field": "type",
                "corporate_clientsform-regNr-field": "regNr",
                "corporate_clientsform-address-field": "address",
                "corporate_clientsform-county-field": "county",
                "corporate_clientsform-locality-field": "locality",
                "corporate_clientsform-iban-field": "iban",
                "corporate_clientsform-bank-field": "bank",
                "corporate_clientsform-paymentTerm-field": "paymentTerm",
                "corporate_clientsform-status-field": "status",
            };

            Object.keys(map).forEach(function(key){

                var value = this.model.get(map[key]);

                if (value !== null && value !== undefined && typeof value === "object") {
                    // relație Backbone/Obiect — extrage .id
                    this.$el.find("#" + key).val(value.id);
                    console.log(value.id)
                } else {
                    // valoare simplă (string, number, boolean)
                    this.$el.find("#" + key).val(value);
                }

                switch (key) {
                    case 'corporate_clientsform-county-field':

                        this.$('#corporate_clientsform-county-field').trigger("chosen:updated");
                        this._onCountyChange();
                        break;

                    case 'corporate_clientsform-locality-field':

                        this.$('#corporate_clientsform-locality-field').one('load', function() {
                            var locality = this.model.get('locality');
                            var localityId = (locality !== null && locality !== undefined && typeof locality === "object")
                                ? locality.id
                                : locality;

                            this.$('#corporate_clientsform-locality-field').val(localityId);
                            this.$('#corporate_clientsform-locality-field').trigger("chosen:updated");
                        }.bind(this));

                        break;

                }

            }.bind(this));
        },

        /**
         * Method that binds validation to the chosen model
         *
         * @param {object} model The model that the validation is being performend on
         * @private
         * @return {undefined}
         */
        _bindValidation: function(model) {

            model = _.isUndefined(model) ? this.model : model;
            Backbone.Validation.unbind(this, {model: model});

            Backbone.Validation.bind(this, {
                valid: this._onValid.bind(this),
                invalid: this._onInvalid.bind(this),
                model: model
            });
        },

        /**
         * Display the error message
         *
         * @param {string} message The message to be shown
         * @private
         * @return {undefined}
         */
        _showError: function(message) {
            // TODO: move in abstract class to be reused

            var errorMessage = Translator.trans('js.error_message_corporate_clients_form');

            // Display mobile alert
            this.$el.find('#corporate_clients-create-general-error-panel')
                .removeClass('hidden')
                .text(message)
                .fadeTo('slow', 1)
                .delay(3000)
                .fadeTo('slow', 0, function(){
                    this.hideMobileAlert();
                }.bind(this));
            // this._isLoading(false);
            //
            // var $error = this._getInformationPanel();
            // $error
            //     .removeClass('hidden alert-success')
            //     .addClass('alert-danger')
            //     .text(message)
            //     .fadeTo('slow', 1)
            //     .delay(5000);
        },

        _displayError: function(res){
            console.log(res.responseJSON);
            var errors = res.responseJSON.errors;

            if (errors.length !== 0) {

                var message = errors;

                if (typeof res.responseJSON != "undefined")
                {
                    this._showError(message);
                }
            }
            // this._resetForm();
        },

        /**
         * Method that handles the form submission
         *
         * @param {Event} e - the event
         * @return {undefined}
         * @private
         */
        _onSubmitForm: function (e) {

            e.preventDefault();

            var formData = this.getFormData();
            this.model.set(formData);

            // 1. Validează câmpurile MAI ÎNTÂI
            var isValid = this.model.isValid(true);

            if (!isValid) {
                this.showMobileAlert();
                return;
            }

            // 2. Apoi verifică reprezentanții
            var hasRepresentatives = this._isValidRepresentatives();

            if (!hasRepresentatives) {
                return;   // ← FĂRĂ asta, submit-ul merge mai departe
            }

            // 3. Continuă spre salvare
            this.$('.representative-validation-error').addClass('hidden');
            this._isLoading(true, this.getSubmitButtonSelector());
            this._addRepresentativesModel(this.model);

            this.model.save(null, {
                success: function (i) {
                    this.model.trigger("success", i);
                }.bind(this),
                error: function(model, res) {
                    this._displayError(res);
                    this._isLoading(false, this.getSubmitButtonSelector());
                }.bind(this)
            });
        },

        /**
         * Method that iterates through the localities
         * returned from php and sets them as options in the
         * locality select
         *
         * @param {object} localities The loclaities corresponding to the county
         * @private
         * @return {undefined}
         */
        _setLocalityOptions: function (localities) {
            for (var index in localities) {
                var opt = document.createElement("option");
                opt.value = localities[index].id;
                opt.innerHTML = localities[index].name;
                this.$('#corporate_clientsform-locality-field').append(opt);
            }
        },

        /**
         * Method that makes the request to get the data
         * for the localities select
         *
         * @private
         * @return {undefined}
         */
        _onCountyChange: function () {
            // Get the county id
            var id = this.$("#corporate_clientsform-county-field option:selected").val();

            this.localitiesCollection.reset(null);

            if (id) {

                this.localitiesCollection.setCountyId(id);

                // Get the localities collection for the given county
                this.localitiesCollection.fetch({
                    success: function() {
                        this.$('#corporate_clientsform-locality-field').trigger("chosen:updated");
                        this.$("#corporate_clientsform-locality-field").trigger('load');
                    }.bind(this)
                });

            } else {

                this.$('#corporate_clientsform-locality-field').trigger("chosen:updated");
            }
        },

        /**
         * Method triggered on the locality collection add
         *
         * @param {object} model - Model binded to the collection
         * @private
         * @return {undefined}
         */
        _onLocalitiesCollectionAdd: function(model){
            this._renderLocality(model);
        },

        /**
         * Method triggered on the locality collection reset
         *
         * @private
         * @return {undefined}
         */
        _onLocalitiesCollectionReset: function(){
            this._renderLocalityReset();
        },

        /**
         * Method that renders the locality select
         *
         * @param {object} model - Model binded to the collection
         * @private
         * @return {undefined}
         */
        _renderLocality: function(model){
            var $option = $('<option>').attr('value', model.get('id')).text(model.get('name'));
            this.$('#corporate_clientsform-locality-field').append($option);
        },

        /**
         * Method that resets the locality select
         *
         * @private
         * @return {undefined}
         */
        _renderLocalityReset: function(){
            var $option = this.$("#corporate_clientsform-locality-field option:eq(0)").detach();
            this.$('#corporate_clientsform-locality-field').empty().append($option);
        },

        /**
         * Method that returns the text for the selected option
         *
         * @private
         * @return {*|jQuery} - Text for the selected county field option
         */
        _getCountyValue: function () {
            return this.$('#worksiteform-county-field').find("option:selected").text();
        },

        /**
         * Method that returns the text for the selected option
         *
         * @private
         * @return {*|jQuery} - Text for the selected locality field option
         */
        _getLocalityValue: function () {
            return this.$('#worksiteform-locality-field').find("option:selected").text();
        },

        /**
         * Method that returns the text for the selected option
         *
         * @private
         * @return {*|jQuery} - Text for the selected status field option
         */
        _getStatusValue: function () {
            return this.$('#worksiteform-status-field').find("option:selected").text();
        },

        _getRepresentativesData: function() {
            var $name = this.$('#corporateClientsRepresentativeForm-name-field');
            var $position = this.$('#corporateClientsRepresentativeForm-position-field');
            var $phone = this.$('#corporateClientsRepresentativeForm-phoneNumber-field');
            var $status = this.$('#corporateClientsRepresentativeForm-status-field');
            var $email = this.$('#corporateClientsRepresentativeForm-email-field');

            return {
                'name': $name.val(),
                'position': $position.val(),
                'phone': $phone.val(),
                'status': $status.val(),
                'email': $email.val(),
            };
        },

        /**
         * Method that populates the array with the data that is
         * added by the user in worksite form
         *
         * @private
         * @return {object} Object filled with model data
         */
        _populateWorksiteData: function () {
            // Getting form data
            var $data = this._getRepresentativesData();

            return {
                name: $data.name,
                position: $data.position,
                status: $data.status,
                phone: $data.phone,
                email: $data.email,
            };
        },

        _createEditButton: function(name, label) {
            return "<span class='"+ name +"-form btn btn-primary'>" + label + "</span>";
        },

        _displayWrapper: function(wrapperName) {
            if (wrapperName.hasClass("hidden")) {
                wrapperName.removeClass("hidden");
            }
        },

        _disableDeleteButton: function() {
            var $deleteButton = this.$('.delete-representative-form');
            if (this.representativesCollection.size() === 1) {
                $deleteButton.prop('disabled', true);
                $deleteButton.addClass('disabled');
            } else if (this.representativesCollection.size() > 1) {
                $deleteButton.prop('disabled', false);
                $deleteButton.removeClass('disabled');
            }
        },
        /**
         * Method that renders the rows for representatives
         *
         * @param {Object} model - The model for the collection
         * @param {bool} remove - If true, the action is removal of rows
         * @private
         * @return {undefined}
         */
        _renderRepresentativeRow: function(model, remove) {
            var $wrapperName = this.$('.representative-list');

            remove = _.isUndefined(remove) ? false : remove;
            var id = model.get('id') ? model.get('id') : model.cid;

            // General elements
            var $tableName = this.$('#corporateClientsRepresentativeForm-list-field');
            var $row = $tableName.find('tbody tr[data-id="' + id + '"]');
            var isEdit = !!$row.length;

            if( remove ){
                $row.remove();
                this.representativesCollection.remove(model.cid);

                // If there are no items in the collection, remove wrapper and table
                if (this.representativesCollection.size() === 0) {
                    this._hideWrapper($wrapperName);
                }
                return;
            }

            if( !isEdit ){
                // Creating dom elements
                var editButtonLabel = Translator.trans('js.btn_edit');
                var $editButton = this._createEditButton('edit-representative', editButtonLabel);
                var $deleteButton = '<div class="delete-representative-form btn"><i class="fa fa-trash-o"></i></div>';

                // Displaying table wrapper
                this._displayWrapper($wrapperName);

                $row = $('<tr>')
                    .attr("data-id", id);

                // Name
                $('<td>')
                    .text(model.get('name'))
                    .appendTo($row);

                // Position
                $('<td>')
                    .text(model.get('position'))
                    .appendTo($row);

                // Phone number
                $('<td>')
                    .text(model.get('phoneNumber'))
                    .appendTo($row);

                // Email
                $('<td>')
                    .text(model.get('email'))
                    .appendTo($row);

                // Actions
                $('<td>')
                    .append($editButton)
                    .append($deleteButton)
                    .appendTo($row);

                // Appending table elements to table
                $tableName.find("tbody").append($row);
            } else {

                $row.find('td:eq(0)').text(model.get('name'));
                $row.find('td:eq(1)').text(model.get('position'));
                $row.find('td:eq(2)').text(model.get('phoneNumber'));
                $row.find('td:eq(3)').text(model.get('email'));
                $row.attr({
                    "data-id": id
                });
            }
            this._disableDeleteButton();
        },

        /**
         * Method that listens to the add and remove events of the collection
         *
         * @param {object} model - The model that is binded to the collection
         * @private
         * @return {undefined}
         */
        _onRepresentativesAdd: function(model){
            this._renderRepresentativeRow(model);
        },

        /**
         * Method that removes the selected entry from the collection
         *
         * @param {object} model - The model that is binded to the collection
         * @private
         * @return {undefined}
         */
        _onRepresentativesRemove: function(model){
            this.representativesCollection.remove(this.representativeEditAddId);
            this._renderRepresentativeRow(model);
        },

        /**
         * Method that listens to the change event of the collection
         *
         * @param {object} model - The model
         * @private
         * @return {undefined}
         */
        _onRepresentativesChange: function(model){
            this._renderRepresentativeRow(model);
        },


        /**
         * Method that removes the representative from the collection
         *
         * @param {Object} model - Model that is binded to the collection
         * @private
         * @return {undefined}
         */
        _onRepresentativesCollectionRemove: function(model){
            this._renderRepresentativeRow(model, true);
        },

        /**
         * Method that adds a representative to the collection
         *
         * @param {Object} model - Model that is binded to the collection
         * @private
         * @return {undefined}
         */
        _onRepresentativesCollectionAdd: function (model) {
            this._renderRepresentativeRow(model);
        },

        /**
         * Method that catches the change event on the collection
         *
         * @param {Object} model - Model that is binded to the collection
         * @private
         * @return {undefined}
         */
        _onRepresentativesCollectionChange: function(model) {
            this._renderRepresentativeRow(model);
        },


        /**
         * Populating the general array with representative data from the form
         *
         * @private
         * @return {object} Object filled with model data
         */
        _populateRepresentativeData: function() {
            var $data = this._getRepresentativesData();

            return {
                repname: $data.name,
                name: $data.name,
                position: $data.position,
                phoneNumber: $data.phone,
                email: $data.email
            };
        },

        _onCreateClientsRepresentative: function () {

            var data = this._populateRepresentativeData();
            var record = new z.ProjectsRepresentativeModel(data);

            // 1. Unbind modelul principal ÎNAINTE de a valida representative-ul
            Backbone.Validation.unbind(this, {model: this.model});

            // 2. Leagă validarea pe modelul representative
            this._bindValidation(record);

            if(!record.isValid(true)){
                // Re-leagă modelul principal înainte de a ieși
                this._bindValidation();
                return;
            }

            // 3. Re-leagă modelul principal
            this._bindValidation();

            if (this.representativeEditAddId){
                var representatives = this.representativesCollection.get(this.representativeEditAddId);
                representatives.set(record.toJSON());
            } else {
                this.representativesCollection.push(record);
            }

            var addingButtonTitle = Translator.trans('js.btn_add');
            this.$('#representativeForm-add-button').html(addingButtonTitle);

            this.$('.representative-validation-error').addClass('hidden');

            this.representativeEditAddId = undefined;

            this._resetFields("corporateClientsRepresentativeForm");
        },

        _onEditRepresentativeForm: function (e) {

            // this.$('#worksiteform-locality-field').one('load', function(){
            //     this.$('#worksiteform-locality-field').val(worksite.get('locality'));
            //     this.$('.chosen-select-locality').trigger("chosen:updated");
            // }.bind(this));
            //
            // this.$('#worksiteform-county-field').val(worksite.get('county')).trigger("change");

            var $editingButtonTitle = Translator.trans('js.btn_edit');
            this.$('#representativeForm-add-button').html($editingButtonTitle);

            var id = $(e.target).parents('tr').data("id");
            var representatives = this.representativesCollection.get(id);
            this.representativeEditAddId = id;



            this.$('#corporateClientsRepresentativeForm-name-field').val(representatives.get('name'));
            this.$('#corporateClientsRepresentativeForm-position-field').val(representatives.get('position'));
            this.$('#corporateClientsRepresentativeForm-phoneNumber-field').val(representatives.get('phoneNumber'));
            this.$('#corporateClientsRepresentativeForm-email-field').val(representatives.get('email'));

        },

        _onDeleteRepresentativeRow: function(e) {
            var id = $(e.target).parents('tr').attr("data-id");
            this.representativesCollection.remove(id);
            this._resetFields("corporateClientsRepresentativeForm");
            this.representativeEditAddId = undefined;
            this._disableDeleteButton();
        },

        /**
         * Method that sets the response in a specific form before saving it to the database
         *
         * @param {Object} model - The vendor model
         * @private
         * @return {undefined}
         */
        _addRepresentativesModel: function(model) {
            var representatives = [];

            this.representativesCollection.each(function(representative){
                representatives.push(representative.toJSON());
            });

            // Setting extra fields representatives on model
            model.set("representatives", representatives);
        },


    });

})(window.z = window.z || {});
